import React, { useEffect, useState, useContext, useRef } from "react";
import { UsersContext } from "../../../providers/Users";
import { CopyIcon } from "../../../assets/icons";
import "./statistics.css";
import Chart from "react-apexcharts";
import html2canvas from "html2canvas";
import { LanguageContext } from "../../../providers/LanguageProvider";

const ResultsReport = () => {
  const {
    answersData,
    improvmentResultsTotal,
    readingSDataRes,
    readingSData,
    readingChainData,
    getText,
    emailReportTexts,
    loading,
    setLoading,
    user
  } = useContext(UsersContext);

  const [text, setText] = useState("");
  const [improvefirstVal, setimprovefirstVal] = useState([]);
  const [improveText, setimproveText] = useState([]);
  const [ageText, setAgeText] = useState("");
  const [readingSpeedText, setReadingSpeedText] = useState("");
  const [readingChainText, setReadingChainText] = useState("");
  const improveResultCopy = [...improvmentResultsTotal];
  const rsReultCopy = [...readingSDataRes];
  const answers = [...answersData];
  const [answersScoresCountState4, setAnswersScoresCountState4] = useState([]);
  const [answersScoresCountState3, setAnswersScoresCountState3] = useState([]);
  const [answersScoresCountState0, setAnswersScoresCountState0] = useState([]);
  const [q4, setQ4] = useState([]);
  const [q3, setQ3] = useState([]);
  const [q0, setQ0] = useState([]);
  const [isCopied, setIsCopied] = useState(false);
  const [readingTestData, setReadingTestData] = useState([]);
  const vergenceChartRef = useRef(null);
  const readingSpeedChartRef = useRef(null);
  const { t, currentLanguage } = useContext(LanguageContext);


  useEffect(() => {
    const storedData = localStorage.getItem("readingTestData");
    if (storedData) {
      setReadingTestData(JSON.parse(storedData));
    }
  }, []);

  useEffect(() => {console.log("emailReportTexts",emailReportTexts)}, [emailReportTexts]);
  const vergenceData =
    Array.isArray(answersData) && answersData.length > 0
      ? answersData.map((entry, index) => ({
          week: `${t('week')} ${index === 0 ? 1 : 6 * index}`, // Dynamically assign weeks
          score: entry.total
        }))
      : [{ week: `${t('week')} 1`, score: 0 }];

  const readingSpeedData = {
    labels: readingTestData.map(
      (entry, index) => `${t('week')} ${index === 0 ? 1 : 6 * index}`
    ),
    series: [
      {
        name: t('lettersLabel'),
        data: readingTestData.map(entry => entry.letters_score || 0),
        color: "#007bff" // Blue
      },
      {
        name: t('wordsLabel'),
        data: readingTestData.map(entry => entry.words_score || 0),
        color: "#f39c12" // Orange
      },
      {
        name: t('sentencesLabel'),
        data: readingTestData.map(entry => entry.sentences_score || 0),
        color: "#27ae60" // Green
      }
    ]
  };

  const commonChartOptions = {
    chart: {
      type: "area",
      height: 250,
      toolbar: { show: false } // Hide toolbar
    },
    stroke: { curve: "smooth", width: 2 }, // Smooth curve
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 0.4,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100]
      }
    },
    dataLabels: { enabled: false } // Remove number labels inside dots
  };

  useEffect(() => {
    getText();
  }, []);

  useEffect(() => {
    if (emailReportTexts && emailReportTexts[currentLanguage]) {
    answerTotalCheckResult();
    calcImprovmentInOldReadingTest();
    calcImprovmentInProprietaryReadingTest();
    answersScores();
    checkUserAge();
    }
  }, [currentLanguage, emailReportTexts]);

  useEffect(() => {
    addImprovefirstVal();
  }, [improveText]);

  const LanguageSelector = () => {
    const { setCurrentLanguage } = useContext(LanguageContext);
    return (
      <select
        onChange={(e) => setCurrentLanguage(e.target.value)}
        value={currentLanguage}
        className="language-selector"
      >
        <option value="en">English</option>
        <option value="sv">Svenska</option>
      </select>
    );
  };

  // Add this function to your component
  const convertChartToImage = async chartRef => {
    try {
      const chartElement = chartRef.current;
      const canvas = await html2canvas(chartElement, {
        backgroundColor: "#ffffff", // Force white background
        scale: 2, // Improve quality
        useCORS: true, // Handle cross-origin images
        removeContainer: false,
        logging: false,
        allowTaint: true,
        foreignObjectRendering: false
      });
      return canvas.toDataURL("image/png", 1.0); // Use maximum quality
    } catch (error) {
      console.error("Error converting chart to image:", error);
      return null;
    }
  };

  const ct = async () => {
    try {
      // Clone the js-output div but remove chart-container elements
      const contentDiv = document
        .getElementsByClassName("js-output")[0]
        .cloneNode(true);

      const styleTag = document.createElement("style");
      styleTag.textContent = `
      strong { font-weight: bold !important; }
      .copyable-snippet { font-family: Arial, sans-serif !important; }
      h4 { font-size: 18px !important; font-weight: bold !important; }
      p { font-size: 14px !important; }
      li { font-size: 14px !important; }
      em { font-style: italic !important; }
    `;
      contentDiv.insertBefore(styleTag, contentDiv.firstChild);

      // Convert charts to images
      const vergenceChartImage = await convertChartToImage(vergenceChartRef);
      const readingSpeedChartImage = await convertChartToImage(
        readingSpeedChartRef
      );

      //  images from charts
      const chartContainers = contentDiv.getElementsByClassName("chart-box");
      if (chartContainers[0] && vergenceChartImage) {
        const vergenceImg = document.createElement("img");
        vergenceImg.src = vergenceChartImage;
        chartContainers[0].innerHTML = "";
        chartContainers[0].appendChild(vergenceImg);
      }

      if (chartContainers[1] && readingSpeedChartImage) {
        const readingSpeedImg = document.createElement("img");
        readingSpeedImg.src = readingSpeedChartImage;
        chartContainers[1].innerHTML = "";
        chartContainers[1].appendChild(readingSpeedImg);
      }

      // Preserve inline styles for specific elements
      const strongElements = contentDiv.getElementsByTagName("strong");
      Array.from(strongElements).forEach(element => {
        if (element.style.fontSize) {
          element.setAttribute(
            "style",
            `font-size: ${element.style.fontSize} !important; font-weight: bold !important;`
          );
        }
      });

      // Convert to HTML string with preserved styles
      const htmlString = `
      <div style="font-family: Arial, sans-serif; color: black;">
        ${contentDiv.innerHTML}
      </div>
    `;

      // Convert the filtered content into a Blob
      const blobInput = new Blob([contentDiv.innerHTML], { type: "text/html" });
      const clipboardItemInput = new window.ClipboardItem({
        "text/html": blobInput
      });

      // Copy the filtered content to clipboard
      navigator.clipboard.write([clipboardItemInput]);

      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 500);
    } catch (e) {
      console.log(e);
    }
  };

  const answersScores = (score, text) => {
    let count;
    let answersScoresCount = [];
    let ResultTexts4 = [];
    let ResultTexts3 = [];
    let ResultTexts0 = [];
    let quesArr = [];
    let lastRes = [];

    answers.splice(1, answers.length - 2);

    answers.map((elem, index, array) => {
      count = elem.details.reduce((accumulator, value) => {
        return {
          ...accumulator,
          [value.value]: (accumulator[value.value] || 0) + 1
        };
      }, {});
      answersScoresCount.push(count);

      if (index === 0) {
        quesArr = [...elem.details];
      }

      if (index === 1) {
        lastRes = [...elem.details];
      }
    });

    const filtertResultImprovedReduce = (a, b, n) => {
      if (a.length > 15) {
        a.pop();
        return a.filter((x, i) => {
          if (x !== undefined) {
            return x.value > b[i].value && x.value === n;
          }
        });
      } else {
        return a.filter((x, i) => {
          if (x !== undefined) {
            return x.value > b[i].value && x.value === n;
          }
        });
      }
    };

    const filtertResultImprovedIncrease = (a, b, n) => {
      if (b.length > 15) {
        b.pop();
        return b.filter((x, i) => {
          if (x !== undefined) {
            return x.value < a[i].value && x.value === n;
          }
        });
      } else {
        return b.filter((x, i) => {
          if (x !== undefined) {
            return x.value < a[i].value && x.value === n;
          }
        });
      }
    };

    let resImproved_4 = filtertResultImprovedReduce(quesArr, lastRes, 4);
    let resImproved_3 = filtertResultImprovedReduce(quesArr, lastRes, 3);
    let resImproved_0 = filtertResultImprovedIncrease(quesArr, lastRes, 0);

    const texts = emailReportTexts[currentLanguage];

    if ("4" in answersScoresCount[0] && !("4" in answersScoresCount[1])) {
      if (
        texts &&
        texts.testAnswersResults &&
        texts.testAnswersResults.improvment &&
        texts.testAnswersResults.improvment.text6
      ) {
        ResultTexts4.push(
          replaceTxt(
            texts.testAnswersResults.improvment.text6,
            answersScoresCount[0]["4"],
            0,
            "#A",
            "#B"
          )
        );
      }
      setQ4(resImproved_4);
    } else if ("4" in answersScoresCount[0] && "4" in answersScoresCount[1]) {
      if (answersScoresCount[0]["4"] > answersScoresCount[1]["4"]) {
        if (
          texts &&
          texts.testAnswersResults &&
          texts.testAnswersResults.improvment &&
          texts.testAnswersResults.improvment.text6
        ) {
          ResultTexts4.push(
            replaceTxt(
              texts.testAnswersResults.improvment.text6,
              answersScoresCount[0]["4"],
              answersScoresCount[1]["4"],
              "#A",
              "#B"
            )
          );
        }
        setQ4(resImproved_4);
      }
    }
    if ("3" in answersScoresCount[0] && !("3" in answersScoresCount[1])) {
      if (
        texts &&
        texts.testAnswersResults &&
        texts.testAnswersResults.improvment &&
        texts.testAnswersResults.improvment.text7
      ) {
        ResultTexts3.push(
          replaceTxt(
            texts.testAnswersResults.improvment.text7,
            answersScoresCount[0]["3"],
            0,
            "#A",
            "#B"
          )
        );
      }
      setQ3(resImproved_3);
    } else if ("3" in answersScoresCount[0] && "3" in answersScoresCount[1]) {
      if (answersScoresCount[0]["3"] > answersScoresCount[1]["3"]) {
        if (
          texts &&
          texts.testAnswersResults &&
          texts.testAnswersResults.improvment &&
          texts.testAnswersResults.improvment.text7
        ) {
          ResultTexts3.push(
            replaceTxt(
              texts.testAnswersResults.improvment.text7,
              answersScoresCount[0]["3"],
              answersScoresCount[1]["3"],
              "#A",
              "#B"
            )
          );
        }
        setQ3(resImproved_3);
      }
    }

    if ("0" in answersScoresCount[1] && !("0" in answersScoresCount[0])) {
      if (
        texts &&
        texts.testAnswersResults &&
        texts.testAnswersResults.improvment &&
        texts.testAnswersResults.improvment.text8
      ) {
        ResultTexts0.push(
          texts.testAnswersResults.improvment.text8.replace(
            "#num",
            answersScoresCount[1]["0"]
          ).replace(
            "questions",
            answersScoresCount[1]["0"] === 1 ? "question" : "questions"
          )
        );
      }
      setQ0(resImproved_0);
    } else if ("0" in answersScoresCount[0] && "0" in answersScoresCount[1]) {
      if (answersScoresCount[0]["0"] < answersScoresCount[1]["0"]) {
        let resNum = answersScoresCount[1]["0"] - answersScoresCount[0]["0"];
        let txt0;
        if (
          texts &&
          texts.testAnswersResults &&
          texts.testAnswersResults.improvment &&
          texts.testAnswersResults.improvment.text8
        ) {
          txt0 = texts.testAnswersResults.improvment.text8.replace(
            "#num",
            resNum
          ).replace(
            "questions",
            resNum === 1 ? "question" : "questions"
          );
        }
        ResultTexts0.push(txt0);
        setQ0(resImproved_0);
      }
    } else if (!(0 in answersScoresCount[0]) && !(0 in answersScoresCount[1])) {
    }
    setAnswersScoresCountState4(ResultTexts4);
    setAnswersScoresCountState3(ResultTexts3);
    setAnswersScoresCountState0(ResultTexts0);
  };

  const replaceTxt = (str, val1, val2, old1, old2) => {
    let nStr = "";
    if (str === undefined) {
      setLoading(true);
    } else {
      nStr = str.replace(old1, val1).replace(old2, val2);
    }
    return nStr;
  };

  const answerTotalCheckResult = () => {
    let totalArr = [];
    let resultText = "";
    let resultImproveText = "";
    let improvment = [];
    answersData.map((ans, i) => {
      totalArr.push(ans.total);
    });
    const texts = emailReportTexts[currentLanguage];

    if (
      totalArr[0] < totalArr[totalArr.length - 1] &&
      totalArr[totalArr.length - 1] - totalArr[0] >= 4
    ) {
      
      if (
        texts &&
        texts.testAnswersResults &&
        texts.testAnswersResults.AllCases &&
        texts.testAnswersResults.AllCases.text4
      ) {
        resultText = replaceTxt(
          texts.testAnswersResults.AllCases.text4,
          totalArr[0],
          totalArr[totalArr.length - 1],
          "#A",
          "#B"
        );
      }
      setText(resultText);
    } else if (
      totalArr[0] < totalArr[totalArr.length - 1] &&
      totalArr[totalArr.length - 1] - totalArr[0] <= 3
    ) {
      if (
        texts &&
        texts.testAnswersResults &&
        texts.testAnswersResults.AllCases &&
        texts.testAnswersResults.AllCases.text1
      ) {
        resultText = replaceTxt(
          texts.testAnswersResults.AllCases.text1,
          totalArr[0],
          totalArr[totalArr.length - 1],
          "#A",
          "#B"
        );
      }
      setText(resultText);
    } else if (
      totalArr[0] === totalArr[totalArr.length - 1]
    ) {
      if (
        texts &&
        texts.testAnswersResults &&
        texts.testAnswersResults.AllCases &&
        texts.testAnswersResults.AllCases.text6
      ) {
        resultText = texts.testAnswersResults.AllCases.text6.replace("#X", totalArr[0]);
      }
      setText(resultText);
    } else if (totalArr[0] > totalArr[totalArr.length - 1] && improveResultCopy.length > 0) {
      if (
        texts &&
        texts.testAnswersResults &&
        texts.testAnswersResults.AllCases &&
        texts.testAnswersResults.AllCases.text5
      ) {
        resultText = replaceTxt(
          texts.testAnswersResults.AllCases.text5,
          totalArr[0],
          totalArr[totalArr.length - 1],
          "#A",
          "#B"
        ).replace("#X", improveResultCopy[improveResultCopy.length - 1]);
      }
      setText(resultText);
    } else {
      let firstValue = totalArr.shift();
      for (const item of totalArr) {
        if (
          texts &&
          texts.testAnswersResults &&
          texts.testAnswersResults.AllCases &&
          texts.testAnswersResults.AllCases.text3
        ) {
          resultImproveText = replaceTxt(
            texts.testAnswersResults.AllCases.text3,
            firstValue,
            item,
            "#A",
            "#B"
          );
        }
        improvment.push(resultImproveText);
      }
      setimproveText(improvment);
    }
  };

  const addImprovefirstVal = () => {
    let improvmentResults = [];
    let withPrecentage = "";
    if (improveText.length === 1) {
      withPrecentage = replaceTxt(
        improveText[0],
        improveResultCopy[0],
        " ",
        "WA",
        "- WB"
      );
      setText(withPrecentage);
    } else {
      const improveResultC = [...improveResultCopy];
      const firstImprovmentValue = improveResultCopy.shift();
      improveResultC.forEach((item, index) => {
        const elem = improveText[index];
        withPrecentage = replaceTxt(elem, item, " ", "WA", "- WB");
        improvmentResults.push(withPrecentage);
      });

      setimprovefirstVal(improvmentResults);
    }
  };

  const checkUserAge = () => {
    const arrTotal = [];
    answersData.map((ans, i) => {
      arrTotal.push(ans.total);
    });
    const texts = emailReportTexts[currentLanguage];
    if (texts && texts.testAnswersResults !== undefined) {
      return user[0].Age >= 21 && arrTotal[arrTotal.length - 1] < 21
        ? setAgeText(
          texts.testAnswersResults.improvment &&
          texts.testAnswersResults.improvment.text2
          )
        : user[0].Age >= 21 &&
          (arrTotal[arrTotal.length - 1] === 22 ||
            arrTotal[arrTotal.length - 1] === 23)
        ? setAgeText(
          texts.testAnswersResults.improvment &&
          texts.testAnswersResults.improvment.text3
          )
        : user[0].Age < 21 && arrTotal[arrTotal.length - 1] < 16
        ? setAgeText(
          texts.testAnswersResults.improvment &&
          texts.testAnswersResults.improvment.text4
          )
        : user[0].Age < 21 &&
          (arrTotal[arrTotal.length - 1] === 17 ||
            arrTotal[arrTotal.length - 1] === 18)
        ? setAgeText(
          texts.testAnswersResults.improvment &&
          texts.testAnswersResults.improvment.text5
          )
        : null;
    }
  };

  const calcImprovmentInOldReadingTest = () => {
    let rsText1 = "";
    let firstWeekImprove = [];
    let sum = 0;
    if (Object.keys(emailReportTexts).length !== 0) {
      const texts = emailReportTexts[currentLanguage];

      const func = param => {
        for (let i = 0; i < param.length; i++) {
          sum += param[i]; //don't forget to add the base
        }
        let avg = sum / param.length;
        const avregeNumOfEvenIndex = Math.round(avg);
        if (
          texts.readingSpeedResults &&
          texts.readingSpeedResults.readingSpeed &&
          texts.readingSpeedResults.rt_negative
        ) {
          if (avregeNumOfEvenIndex < 0 || isNaN(avregeNumOfEvenIndex)) {
            rsText1 = texts.readingSpeedResults.rt_negative.replace(
              "X",
              avregeNumOfEvenIndex
            );
          }else{
            rsText1 = texts.readingSpeedResults.readingSpeed.replace(
              "avg",
              `${avregeNumOfEvenIndex}%. ${t('greatJob')}`
            );
          }
          
        }
        return rsText1;
      };

      rsReultCopy.forEach((item, index) => {
        firstWeekImprove.push(item[item.length - 1]);
      });

      func(firstWeekImprove);

      let lastRSTxt = "";
      const mapObj = {
        improve1: firstWeekImprove[0],
        improve2: firstWeekImprove[1],
        improve3: firstWeekImprove[2]
      };
      lastRSTxt = rsText1.replace(
        /\b(?:improve1|improve2|improve3)\b/gi,
        matched => mapObj[matched]
      );
      setReadingSpeedText(lastRSTxt);
    }
  };

  const calcImprovmentInProprietaryReadingTest = () => {
    let rsText1 = "";
    let firstWeekImprove = [];
    let sum = 0;

    if (Object.keys(emailReportTexts).length !== 0) {
      const texts = emailReportTexts[currentLanguage];
      const func = param => {
        for (let i = 0; i < param.length; i++) {
          sum += param[i]; //don't forget to add the base
        }
        // calculate the average value of 6 week test
        let avg = sum / param.length;
        const avregeNumOfEvenIndex = Math.round(avg);
        // replace the suitable "avg" in db with the average value
        if (
          texts.readingSpeedResults &&
          texts.readingSpeedResults.readingSpeed &&
          texts.readingSpeedResults.rt_negative
        ) {
          if (avregeNumOfEvenIndex < 0 || isNaN(avregeNumOfEvenIndex)) {
            rsText1 = texts.readingSpeedResults.rt_negative.replace(
              "X",
              avregeNumOfEvenIndex
            );
          }else{
            rsText1 = texts.readingSpeedResults.readingSpeed.replace(
              "avg",
              `${avregeNumOfEvenIndex}%. ${t('greatJob')}`
            );
          }
          
        }
        return rsText1;
      };

      readingChainData.forEach((item, index) => {
        firstWeekImprove.push(item[item.length - 1]);
      });

      func(firstWeekImprove);

      let lastRSTxt = "";
      const mapObj = {
        improve1: firstWeekImprove[0],
        improve2: firstWeekImprove[1],
        improve3: firstWeekImprove[2]
      };
      // assign the the improving value with the suitable text
      lastRSTxt = rsText1.replace(
        /\b(?:improve1|improve2|improve3)\b/gi,
        matched => mapObj[matched]
      );
      setReadingChainText(lastRSTxt);
    }
  };

  return (
    <div className="container">
      <div>
      <LanguageSelector />
        {loading ? (
          <h1>Loading...</h1>
        ) : (
          <div className="js-output">
            <div className="userInfo">
              {user[0] && user[0].FirstName && (
                <h4 className="copyable-snippet">{`${t('greeting')} ${user[0].FirstName},`}</h4>
              )}
              <button className="copy-btn" onClick={ct}>
                {isCopied ? "✅ Copied" : <CopyIcon />}
              </button>
            </div>
            <p className="copyable-snippet">
            {t('surveyIntro')}
            </p>
            <p className="copyable-snippet">
            {t('surveyRequest')}&nbsp;
                <a href="https://forms.gle/y87o8AJrM4HYLsC59">{t('surveyLink')}</a>
            </p>
            {text.length > 0 ? (
              <p className="copyable-snippet">
                <strong>{text}</strong>
              </p>
            ) : (
              improvefirstVal.map((text1, key) => {
                if (key === improvefirstVal.length - 1) {
                  return (
                    <p className="copyable-snippet" key={key}>
                      <strong>{text1}</strong>
                    </p>
                  );
                }
              })
            )}
            <p className="copyable-snippet">{ageText}</p>
            {!answersScoresCountState4.length &&
            !answersScoresCountState3.length &&
            !answersScoresCountState0.length ? null : (
              <div>
                <h4 className="copyable-snippet">
                {t('importantImprovements')}
                </h4>
                {emailReportTexts ? (
                  <div>
                    {answersScoresCountState4 &&
                      answersScoresCountState4.map((item, key) => {
                        return (
                          <div key={key}>
                            <p className="copyable-snippet">{item}</p>
                            <p className="copyable-snippet">
                            {q4.length > 1 ? t('theseAre') : t('thisIs')}
                            </p>
                          </div>
                        );
                      })}
                    {q4.length ? (
                      <div>
                        <ul>
                          {q4.map((item, key) => {
                            return (
                              <li key={key}>
                                <em className="copyable-snippet">
                                  <strong>{item.question}</strong>
                                </em>
                                <br />
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    ) : null}
                    {answersScoresCountState3 &&
                      answersScoresCountState3.map((item, key) => {
                        return (
                          <div key={key}>
                            <p className="copyable-snippet">{item}</p>
                            <p className="copyable-snippet">
                            {q3.length > 1 ? t('theseAre') : t('thisIs')}
                            </p>
                          </div>
                        );
                      })}
                    {q3.length ? (
                      <div>
                        <ul>
                          {q3.map((item, key) => {
                            return (
                              <li key={key}>
                                <em className="copyable-snippet">
                                  <strong>{item.question}</strong>
                                </em>
                                <br />
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    ) : null}
                    {answersScoresCountState0 &&
                      answersScoresCountState0.map((item, key) => {
                        return (
                          <div key={key}>
                            <p className="copyable-snippet">{item}</p>
                            <p className="copyable-snippet">
                            {q0.length > 1 ? t('theseAre') : t('thisIs')}
                            </p>
                          </div>
                        );
                      })}
                    {q0.length ? (
                      <div>
                        <ul>
                          {q0.map((item, key) => {
                            return (
                              <li key={key}>
                                <em className="copyable-snippet">
                                  <strong>{item.question}</strong>
                                </em>
                                <br />
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    ) : null}
                  </div>
                ) : null}
              </div>
            )}
            {/* Vergence Test Scores */}
            <div ref={vergenceChartRef} className="chart-box">
                  <h3>{t('vergenceTitle')}</h3>
                  <Chart
                    options={{
                      ...commonChartOptions,
                      xaxis: {
                        categories: vergenceData.map(data => data.week)
                      },
                      colors: ["#007bff"], // Blue color for vergence
                      markers: {
                        size: 5,
                        colors: ["#007bff"], // Blue dots
                        strokeColors: "#fff",
                        strokeWidth: 2,
                        hover: { size: 7 }
                      }
                    }}
                    series={[
                      {
                        name: t('symptomScoreLabel'),
                        data: vergenceData.map(data => data.score)
                      }
                    ]}
                    type="area"
                    height={250}
                  />
                  <br />
                </div>
            <br />
            <h4 className="copyable-snippet">{t('readingSpeedTitle')}</h4>
            <ul>
              {readingChainText.split(",").map((txt, key) => {
                if (key === 0) {
                  return (
                    <div key={key}>
                      <em className="copyable-snippet">
                        <strong>{txt}</strong>
                      </em>
                      <br />
                    </div>
                  );
                } else {
                  return (
                    <li key={key}>
                      <em className="copyable-snippet">
                        <strong>{txt}</strong>
                      </em>
                      <br />
                    </li>
                  );
                }
              })}
            </ul>
            <div ref={readingSpeedChartRef} className="chart-box">
              <h3>{t('readingSpeedChartTitle')}</h3>
              <Chart
                options={{
                  ...commonChartOptions,
                  xaxis: { categories: readingSpeedData.labels },
                  colors: readingSpeedData.series.map(s => s.color), // Dynamic colors
                  markers: {
                    size: 5,
                    colors: readingSpeedData.series.map(s => s.color), // Match dot color to line
                    strokeColors: "#fff",
                    strokeWidth: 2,
                    hover: { size: 7 }
                  }
                }}
                series={readingSpeedData.series.map(s => ({
                  name: s.name,
                  data: s.data
                }))}
                type="area"
                height={250}
              />
            </div>
            {/* <h4 className="copyable-snippet">Kalibrering</h4>
            <p className="copyable-snippet">
              {emailReportTexts &&
                emailReportTexts.readingSpeedResults &&
                emailReportTexts.readingSpeedResults.VergenceFunction}
            </p> */}
            <br />
            <h4 className="copyable-snippet">{t('trainingTitle')}</h4>
            <p className="copyable-snippet">
              {emailReportTexts &&
                emailReportTexts[currentLanguage].readingSpeedResults &&
                emailReportTexts[currentLanguage].readingSpeedResults.training &&
                emailReportTexts[currentLanguage].readingSpeedResults.training.text5}
              &nbsp;{t('excellent')}</p>

            <h4 className="copyable-snippet">{t('recommendationTitle')}</h4>
            <p className="copyable-snippet">
            {t('congratsMessage')}
            <br />
            <br />
            {t('trainingProgressMessage')}
            <br />
          </p>

          <h4>{t('trainingGoodbye')}</h4>

          <p>{t('socialShareRequest')}</p>
          <strong>{t('socialMediaTitle')}</strong>
          <br />

          <a
            href="https://www.facebook.com/imvilabs"
            target="_blank"
            rel="noreferrer"
          >
            <strong>https://www.facebook.com/imvilabs</strong>
          </a>
          <br />
          <a
            href="https://www.instagram.com/imvilabs/"
            target="_blank"
            rel="noreferrer"
          >
            <strong>https://www.instagram.com/imvilabs/</strong>
          </a>
          <br />
          <a
            href="https://se.linkedin.com/company/imvi-labs-ab"
            target="_blank"
            rel="noreferrer"
          >
            <strong>https://se.linkedin.com/company/imvi-labs-ab</strong>
          </a>
          <br />
          <a
            href="https://www.youtube.com/@imvi9346"
            target="_blank"
            rel="noreferrer"
          >
            <strong>https://www.youtube.com/imvilabs</strong>
          </a>
        </div>
      )}
      </div>
    </div>
  );
};

export default ResultsReport;
